import React, { useState } from 'react';
import { 
    DefaultButton, 
    Panel, 
    PanelType, 
    Text, 
    TextField, 
    IPanelStyles,
} from '@fluentui/react';
import LoaderComponent from '../loader/loader.component';
import ErrorMessageComponent from '../error-message/error-message.component';

import ApiService from '../../services/api/api.service';
import useAuthStatus from '../../hooks/auth/AuthHook';

const panelStyles : IPanelStyles = {
    root: {},
    overlay: {},
    hiddenPanel: {},
    main: {},
    commands: {},
    contentInner: {},
    scrollableContent: {},
    navigation: {},
    header: {},
    headerText: {},
    content: {},
    footer: {},
    footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: {
                color: 'rgb(50, 49, 48)',
            },
        },
    },
};

interface IChangePasswordComponentProps {
    isOpen: boolean;
    onClose: () => void;
};

const ChangePasswordComponent = (props: IChangePasswordComponentProps) => {
    const [password, setPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [repeatPassword, setRepeatPassword] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const auth = useAuthStatus();

    const onChangePassword = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) : void => {
        setPassword(newValue || "");
    };

    const onChangeNewPassword = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) : void => {
        setNewPassword(newValue || "");
    };

    const onChangeRepeatPassword = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) : void => {
        setRepeatPassword(newValue || "");
    };

    const onKeyUp = (event: React.KeyboardEvent) : void => {
        if (event.key === "Enter") {
            onSubmit();
        }
    };

    const onSubmit = () : void => {
        if (auth.user) {
            setError('');
            if (newPassword !== repeatPassword) {
                setError('Las nuevas contraseñas ingresadas no coinciden.');
            }
            else {
                setLoading(true);
                ApiService.Post<void>("Usuarios", "SetPassword", auth.user, {
                    "Actual": password,
                    "Nueva": newPassword,
                }).then(() => {
                    props.onClose();
                    setLoading(false);
                }, (error: string) => {
                    setError(error);
                    setLoading(false);
                });
            }
        }
    };

    return (
        <Panel 
            id="ModalCambiarContrasena" 
            isOpen={props.isOpen} 
            onDismiss={props.onClose} 
            type={PanelType.medium}
            headerText='Cambiar contraseña'
            styles={panelStyles}>
            <div className="container-fluid p-0">
                <div className="row m-0">
                    <div className='col-12'>
                        <Text className="my-1 d-block">
                            Contraseña actual:
                        </Text>
                        <TextField
                            type="password"
                            canRevealPassword={false}
                            onChange={onChangePassword}
                            value={password}
                            onKeyUp={onKeyUp} />
                    </div>
                    <div className='col-12'>
                        <Text className="my-1 d-block">
                            Nueva contraseña:
                        </Text>
                        <TextField
                            type="password"
                            canRevealPassword={false}
                            onChange={onChangeNewPassword}
                            value={newPassword}
                            onKeyUp={onKeyUp} />
                    </div>
                    <div className='col-12'>
                        <Text className="my-1 d-block">
                            Confirmar nueva contraseña:
                        </Text>
                        <TextField
                            type="password"
                            canRevealPassword={false}
                            onChange={onChangeRepeatPassword}
                            value={repeatPassword}
                            onKeyUp={onKeyUp} />
                    </div>
                    <div className='col-12 mt-3'>
                        <DefaultButton 
                            text='Cambiar contraseña'
                            iconProps={{
                                iconName: 'Save',
                            }}
                            onClick={onSubmit} />
                    </div>
                </div>
            </div>
            <ErrorMessageComponent message={error} />
            <LoaderComponent loading={loading} />
        </Panel>
    );
};

export default ChangePasswordComponent;
